/**
 * Admin Events — upcoming first, then a short tail of recent past events.
 * Tapping any card opens the shared event detail page, where volunteer work
 * gets posted.
 */

import { useNavigate } from 'react-router-dom';
import { today } from '../../data';
import { useClubData } from '../../context/ClubContext';
import { useUI } from '../../context/UIContext';
import { EventCard, trendingEventId } from '../../components/EventCard';
import { EventSheet } from '../../components/sheets/ClubSheets';
import { Button, ButtonRow, Empty, Eyebrow, ViewTitle } from '../../components/ui';

/** How many finished events to keep visible before it becomes clutter. */
const PAST_SHOWN = 4;

export function AdminEventsPage() {
  const { db } = useClubData();
  const { openSheet } = useUI();
  const navigate = useNavigate();
  const now = today();

  const upcoming = db.events
    .filter((e) => e.date >= now)
    .sort((a, b) => a.date.localeCompare(b.date));
  // The one event the club is turning up for gets the flame.
  const hot = trendingEventId(db.events, now);
  const past = db.events
    .filter((e) => e.date < now)
    .sort((a, b) => b.date.localeCompare(a.date));

  const open = (id) => {
    navigate(`/a/events/${id}`);
    window.scrollTo(0, 0);
  };

  return (
    <>
      <ViewTitle
        title="Events & meetings"
        sub="Runs, races, committee meetings and volunteer duty"
      />

      <div className="mb-[18px]">
        <ButtonRow>
          <Button tone="p" onClick={() => openSheet(<EventSheet />)}>
            + Create event
          </Button>
        </ButtonRow>
      </div>

      <Eyebrow>Upcoming</Eyebrow>
      {upcoming.length ? (
        upcoming.map((e) => (
          <EventCard key={e.id} event={e} db={db} meId={null} onOpen={open} trending={e.id === hot} />
        ))
      ) : (
        <Empty title="Nothing scheduled">Create your first event.</Empty>
      )}

      {past.length > 0 && (
        <>
          <Eyebrow>Past</Eyebrow>
          {past.slice(0, PAST_SHOWN).map((e) => (
            <EventCard key={e.id} event={e} db={db} meId={null} onOpen={open} />
          ))}
        </>
      )}
    </>
  );
}
